// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"f0743556","328":"ddee6a6d","355":"c9d67458","453":"019b7167","651":"5ea80bde","857":"90f95c67","994":"30b24d97"}[chunkId] + ".chunk.js";
};